<template>
    <div class="publicMobileInfo">

        <div class="phone">
            <div class="card">
                <div class="content">
                    <p class="name">{{datainfo.name}}</p>
                    <p class="time">时间</p>

                    <p v-for="(columnlist,index) in datainfo.columnlist">
                        {{columnlist.name}}
                        <span :style="'color:'+colorlist[index]" :class="{'firstdata':index===0,'remark':index===3}">
                            <template v-pre>{{</template>{{columnlist.key }}<template v-pre>}}</template>
                        </span>
                    </p>
                </div>
                <div class="goto">详情 <span>></span></div>
            </div>
        </div>
        <div class="info">
            <div class="item">
                <p>模版ID</p>
                <p>{{datainfo.wxtemplateid}}</p>
            </div>
            <div class="item">
                <p>模版名称</p>
                <p>{{datainfo.name}}</p>
            </div>
            <div class="item">
                <p>行业</p>
                <p>{{datainfo.industryname}}</p>
            </div>
            <div class="item">
                <p>模版内容</p>
                <ul>
                    <li v-for="(columnlist,index) in datainfo.columnlist">
                        <p class="txt">
                            <!--<span>-->
                            {{ columnlist.name}}<template v-pre>{{</template>{{columnlist.key }}<template v-pre>}}</template>
                            <!--</span>-->
                        </p>
                        <p>字体颜色</p>
                        <el-color-picker v-model="colorlist[index]"></el-color-picker>
                        <el-button @click="clear(index)">重置</el-button>
                    </li>
                </ul>

                <div class="btn">
                    <el-button @click="back()">取消</el-button>
                    <el-button type="primary" @click="submit()">保存</el-button>
                </div>

            </div>

        </div>

    </div>
</template>

<script>
    import {updateMpmessageTemplateColor, findMpmessageTemplateInfo} from '@/api/accountApi'
    import Loading from 'base/loading/loading'    // 引入 loading 组件
    import {mapGetters, mapActions} from 'vuex'
    // import query from 'jquery'
    export default {
        name: "publicMobileInfo",
        data() {
            return {
                innerid: this.$route.query.innerid,
                token: JSON.parse(sessionStorage['user']).loginToken, // token
                shopID: JSON.parse(sessionStorage['shop']).ShopID, // 店铺id
                sessionUser: JSON.parse(sessionStorage['user']), // 用户信息
                datainfo: [],
                colorlist: []
            }
        },
        mounted() {
            var data = {
                // LoginToken: this.token,
                // ShopID: this.shopID,
                ClientType: 3,
                innerid: this.innerid
            }
            this.setLoading(true)
            findMpmessageTemplateInfo({
                data: data,
                success:data => {
                    this.setLoading(false)
                    this.datainfo = data.data
                    var datainfocolor = this.datainfo.columnlist
                    for(var i = 0; i < datainfocolor.length; i++) {
                        this.colorlist[i] = datainfocolor[i].color
                    }
                    console.log(data)
                },
                error:data => {
                    this.setLoading(false)
                }
            })
        },
        methods: {
            back() {
                this.$router.go(-1)
            },
            submit() {
                var colorArray = '', data;

                for (var i = 0; i < this.colorlist.length; i++) {

                    if (i == this.colorlist.length-1) {
                        colorArray += this.colorlist[i]
                    } else {
                        colorArray += this.colorlist[i]+","
                    }

                }
                // console.log(colorArray)
                data = {
                    // LoginToken: this.token,
                    // ShopID: this.shopID,
                    ClientType: 3,
                    innerid: this.innerid,
                    colorlist: colorArray
                }
                updateMpmessageTemplateColor({
                    data: data,
                    success:data => {
                        this.setLoading(false)
                        this.$message.success('保存成功')
                    },
                    error:data => {
                        this.setLoading(false)
                        if (data.code == '301') {
                            this.$message.success(data.msg)
                        } else {
                            this.$message.success('保存失败')
                        }
                    }
                })
            },
            clear(index) {
                var datainfocolor = this.datainfo.columnlist
                for(var i = 0; i < datainfocolor.length; i++) {
                    if (index === i) {
                        this.colorlist[i] = datainfocolor[i].color
                    }
                }

                this.colorlist = JSON.parse(JSON.stringify(this.colorlist))
                // Object.assign({},,this.colorlist)

                // console.log(this.colorlist)
            },
            ...mapActions ([
                'setLoading'
            ])
        },
        components: {Loading}
    }
</script>

<style lang="scss" type="text/scss">
    .publicMobileInfo {
        overflow: hidden;
        .phone {
            float: left;
            display: block;
            position: relative;
            width: 406px;
            height: 782px;
            background: url("../../../common/images/accountmgt/white.png") no-repeat;
            background-size: 406px 782px;

            .card {
                position: absolute;
                margin: auto;
                top: 157px;
                left: 0;
                right: 0;
                width: 294px;
                height: 238px;
                background: #fff;

                .content {
                    padding: 10px;
                    height: 204px;
                    box-sizing: border-box;

                    p {
                        margin-top: 6px;
                        font-size: 13px;
                    }
                    .name {
                        font-size: 18px;
                        color: #000;
                        font-weight: bold;
                    }
                    .time {
                        font-size: 13px;
                        color: #909399;
                    }
                    .firstdata {
                        display: block;
                        margin-top: 9px;
                        margin-bottom: 15px;
                    }
                    .remark {
                        display: block;
                        margin-top: 30px;
                    }
                }
                .goto {
                    padding: 0 10px;
                    line-height: 34px;
                    font-size: 13px;
                    border-top: solid 1px #eee;
                    span {
                        float: right;
                        color: #ccc;
                        text-align: right;
                    }
                }
            }
        }
        .item {
            margin-bottom: 30px;
            min-height: 13px;
            ul {
                /*float: left;*/
                clear: both;
                display: inline-block;
                margin-top: -10px;
                width: 460px;
                li {
                    margin-bottom: 25px;
                    height: 50px;
                    overflow: hidden;
                    border-bottom: solid 1px #DCDFE6;

                    p {
                        float: left;
                        margin-right: 20px;
                        line-height: 30px;
                        color: #303133 !important;
                    }

                    p.txt {
                        width: 200px;
                        color: #606266;
                    }

                    .el-color-picker__trigger {
                        width: 60px;
                        height: 30px;
                    }
                    .el-color-picker,
                    .el-button {
                        float: left;
                        min-width: 60px;
                        width: 60px;
                        height: 30px;
                        border-radius: 0;
                    }

                    .el-button {
                        margin-left: 20px;
                    }

                }
            }
            p {
                float: left;
                min-width: 80px;
                font-size: 14px;
            }
            p:nth-child(2) {
                color: #606266;
            }

        }
        .btn {
            margin-left: 80px;
            margin-top: 130px;
        }
        .info {
            float: left;
            margin-top: 30px;
        }
    }
</style>
